import type { RouteRecordRaw } from "vue-router";
import { setSelectedWashingMachine } from "../guards";

export const washingMachineRoutes: RouteRecordRaw[] = [
  {
    path: "/washingmachine/new",
    name: "washingmachine-new",
    // @ts-ignore TODO: convert view to typescript
    component: () => import("../../views/Admin/EditWashingMachineView.vue"),
    meta: { requiresAuth: true, requiresStaff: true },
  },
  {
    path: "/washingmachine/:id",
    name: "washingmachine",
    // @ts-ignore TODO: convert view to typescript
    component: () => import("../../views/Admin/WashingMachineView.vue"),
    meta: { requiresAuth: true, requiresStaff: true },
    beforeEnter: [setSelectedWashingMachine],
  },
  {
    path: "/washingmachine/:id/edit",
    name: "washingmachine-edit",
    // @ts-ignore TODO: convert view to typescript
    component: () => import("../../views/Admin/EditWashingMachineView.vue"),
    meta: { requiresAuth: true, requiresStaff: true },
    beforeEnter: [setSelectedWashingMachine],
  },
];
